import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import FeedMapping from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { feedMappingSchema, uiSchema } from './Schema';

export default class NewFeedMapping extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  render() {
    const { fetching, feedMapping } = this.props;

    return (
      <div className="feed-mapping-list-container">
        <FeedMapping
          schema={feedMappingSchema}
          uiSchema={uiSchema}
          formData={feedMapping}
          onSubmit={this.onSubmit}
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Submit
          </Button>
        </FeedMapping>
      </div>
    );
  }
}

NewFeedMapping.propTypes = {
  fetching: PropTypes.bool,
  feedMapping: PropTypes.object,
  onCreate: PropTypes.func,
};
